export interface WaterClass {
  code: string;
  label: string;
  description: string;
}

export const WATER_CLASSES: Record<string, WaterClass> = {
  'SA': {
    code: 'SA',
    label: 'Class SA',
    description: 'Best usages are shellfishing for market purposes, primary and secondary contact recreation and fishing'
  },
  'SB': {
    code: 'SB',
    label: 'Class SB',
    description: 'Best usages are primary and secondary contact recreation and fishing'
  },
  'SB(WW)': {
    code: 'SB(WW)',
    label: 'Class SB(WW)',
    description: 'Best usages of Class SB waters with limited suspension following qualifying rain events'
  },
  'SC': {
    code: 'SC',
    label: 'Class SC',
    description: 'Best usage is fishing. Factors other than water quality limit recreational uses.'
  },
  'I': {
    code: 'I',
    label: 'Class I',
    description: 'Best usages are secondary contact recreation and fishing'
  },
  'SD': {
    code: 'SD',
    label: 'Class SD',
    description: 'Best usage is fishing. Natural or man-made conditions limit fish propagation.'
  }
};

export function getWaterClassInfo(classCode?: string): WaterClass | null {
  if (!classCode) return null;
  return WATER_CLASSES[classCode] ?? null;
}
